import React, { useEffect, useState } from "react";
import PSCircle from "components/globals/ui/PSCircle";
import Single from "components/globals/image/Single";
import { NavLink } from "react-router-dom";
import { useAuth } from "providers/AuthContext";

const ORSProfile = () => {
	const [profileImage, setProfileImage] = useState(null);
	const { userInfo, isFetching } = useAuth();

	useEffect(() => {
		if (userInfo) {
			setTimeout(function () {
				setProfileImage(userInfo?.gallery[0]);
			}, 500);
		}
	}, [userInfo]);

	return (
		<>
			{!isFetching && userInfo && (
				<NavLink to="/dashboard/overview">
					<PSCircle>
						<Single
							key={profileImage}
							image={profileImage}
							fill
						/>
					</PSCircle>
				</NavLink>
			)}
		</>
	)
}


export default ORSProfile;